import { createSelector } from 'reselect'
import isEmpty from 'lodash/isEmpty'

const getAccountManager = state => state.views.candidateDetails_LEGACY.accountManager.profile

export const accountManager = createSelector([getAccountManager], accountManager =>
  isEmpty(accountManager)
    ? null
    : {
        label: accountManager.name,
        mention: accountManager.notes_handle,
        accountManager: true,
      },
)
